'use client'

import ModalPage from '@/components/layouts/ModalPage';
import useFacilitiesWithIcons from '@/hooks/useFacilitiesWithIcons';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import { Provider1HotelType } from '@/types/provider1';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import HotelBoxV2 from './HotelBoxV2';
import NavigateButton from './NavigateButton';
import slugify from 'slugify';
import { slugifyOptions } from '@/utils/slugifyOptions';

export default function Facilities({ hotelData, city, hotelName }: { hotelData: Provider1HotelType, city: string, hotelName: string }) {
    const [showAmenities, setShowAmenities] = useState(false)

    const { getSearchParamsString } = useSetSearchParams()

    const facils = useFacilitiesWithIcons(hotelData.facilities)

    return (
        <HotelBoxV2 className=''>
            <div className=''>
                <HotelBoxV2.Header>
                    Amenities
                </HotelBoxV2.Header>
            </div>
            <HotelBoxV2.Body>
                <div className='grid grid-cols-2 gap-3 text-xs font-normal text-neutral-800'>
                    {facils?.slice(0, 6).map((item, index: number) => <div key={item.iconName}
                        className='grid grid-cols-[16px,_1fr] gap-2'>
                        <span className='flex justify-center text-neutral-500 text-sm'>
                            {item.iconElement || <FontAwesomeIcon className='text-neutral-500' icon={faCheckCircle} />}
                        </span>
                        <span className='line-clamp-1 text-xs text-neutral-800 font-normal'>
                            {item.iconName}
                        </span>
                    </div>)}

                </div>
            </HotelBoxV2.Body>
            <HotelBoxV2.Footer>
                {facils.length > 6 && <NavigateButton
                    actionMessage={'opened more facilities'}
                    to={`/hotel/${slugify(hotelData.country, slugifyOptions)}/${slugify(hotelData.city, slugifyOptions)}/${slugify(hotelData.name, slugifyOptions)}/facilities?${getSearchParamsString()}`}
                    className='text-secondary-500 text-xs flex items-center gap-2'>
                    See All Facilities
                    <FontAwesomeIcon icon={faChevronRight} />
                </NavigateButton>}
            </HotelBoxV2.Footer>
            <ModalPage modalHeight='fit-content' hideButton title='Amenities' onClose={() => setShowAmenities(false)} show={showAmenities}>
                <div className='flex flex-col mb-4 gap-2  pb-8'>
                    <p className='text-sm font-bold w-full mb-4 pb-4 text-center mt-2 border-b'>Amenities</p>
                    {facils.map((item, index: number) => <div key={item.iconName}
                        className='grid grid-cols-[20px,_1fr] items-center gap-2'>
                        <span className='flex justify-center text-neutral-500'>

                            {item.iconElement || <FontAwesomeIcon size='sm' className='text-neutral-500' icon={faCheckCircle} />}
                        </span>
                        <span className='line-clamp-1 text-sm font-normal'> {item.iconName}</span>
                    </div>)}
                </div>

            </ModalPage>

        </HotelBoxV2>
    );
}